import API from "@/api/lib/api";

// how to use

export const getAllStaff = async (perPage = 10, page = 1) => {
  try {
    const response = await API.get(
      `staff?per_page=${perPage}&page=${page}&order_by=created_at&order_direction=desc`
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const addStaff = async (data) => {
  try {
    const response = await API.post(`staff`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateStaff = async (id, data) => {
  try {
    const response = await API.put(`staff/${id}`, data);
    return response.data;
  } catch (error) {
    // console.log(error)
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

// how to use
// const res = await staffSearch({
//   restaurantId: 1,
//   first_name: "raihan",
//   last_name: "",
//   email: "",
//   phone: ""
// });

export const staffSearch = async ({
  restaurantId,
  first_name,
  last_name,
  email,
  phone,
}) => {
  try {
    const response = await API.get(`restaurants/${restaurantId}/staff/search`, {
      params: {
        first_name: first_name,
      },
    });
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getStaffStatistics = async (restaurantId) => {
  try {
    const response = await API.get(
      `restaurants/${restaurantId}/staff/statistics`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleStaff = async (staffId) => {
  try {
    const response = await API.get(`staff/${staffId}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


// get Staff scheSchedule by id
export const staffSchedule = async (id) => {
  try {
    const response = await API.get(`staff-shift-schedule/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteStaff = async (staffId) => {
  try {
    const response = await API.delete(`staff/${staffId}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getAllStaffSchedules = async (restaurantId, perPage) => {
  try {
    const response = await API.get(
      `restaurant/staff-schedules/${restaurantId}&per_page=${perPage}`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getAllRole = async () => {
  try {
    const response = await API.get(`acl/roles`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

